import { useQuery } from '@tanstack/react-query';
import ApiConfig from 'src/config/api-config';
import { WeeklySchedule } from 'src/screens/OnboardingTrainer/screens/Schedule/utils/timezoneUtils';

export interface UnavailableTimeSlot {
  id: string;
  start: string;
  end: string;
}

export interface UnavailableDateEntry {
  date: string; // ISO date "YYYY-MM-DD"
  allDay: boolean;
  slots: UnavailableTimeSlot[];
  reason?: string;
}

export interface ConnectedCalendarInfo {
  provider: 'google' | 'apple' | null;
  connected: boolean;
  email?: string;
}

export interface ScheduleResponse {
  status: string;
  data: {
    timezone: string;
    weekly_schedule: WeeklySchedule;
    ai_responses_enabled?: boolean;
    unavailable_dates?: UnavailableDateEntry[];
    connected_calendar?: ConnectedCalendarInfo;
  };
}

export const fetchTrainerSchedule = async (uid: string): Promise<ScheduleResponse> => {
  const apiUrl = `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.TRAINER_GET_SCHEDULE}?uid=${uid}`;
  const response = await fetch(apiUrl);

  if (!response.ok) {
    if (response.status === 404) {
      return {
        status: 'ok',
        data: {
          timezone: '',
          weekly_schedule: {} as WeeklySchedule,
        },
      };
    }
    throw new Error('Failed to fetch trainer schedule');
  }

  return response.json();
};

export function useGetTrainerSchedule(uid?: string) {
  return useQuery({
    queryKey: ['trainer-schedule', uid],
    queryFn: async () => {
      if (!uid) return null;
      return fetchTrainerSchedule(uid);
    },
    enabled: !!uid,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
